export const STREAM_GUARDIAN_API_BASE_URL =
   process.env.REACT_APP_STREAM_GUARDIAN_API_BASE_URL || 'https://guardian.nanostream.cloud';
export const ANALYTICS_SERVICE_API_BASE_URL =
   process.env.REACT_APP_ANALYTICS_SERVICE_API_BASE_URL || 'https://metrics.nanocosmos.de';

export const environment = process.env.REACT_APP_RUM_ENV ? process.env.REACT_APP_RUM_ENV : process.env.NODE_ENV;
